/**
 * created by lzy 2019-12-08
 * 报题关联指令
 */
'use strict';
angular.module('relatedReportDirectiveModule', []).directive('relatedReport', [
    'editingCenterService',
    'trsHttpService',
    '$state',
    'publicToolService',
    'localStorageService',
    '$sessionStorage',
    function (editingCenterService, trsHttpService, $state, publicToolService, localStorageService, $sessionStorage) {
        return {
            restrict: 'E',
            repalace: false,
            scope: {
                mediaType: '@', // 渠道类型数
                metaDataId: '@', // 稿件id
                isFusionEditor: '@', // 判断是否是融合编辑器
                selectedReport: '=', // 选中的报题
                selectedTask: '=', // 选中的任务
            },
            templateUrl: './editingCenter/directive/relatedReport/main.html',
            link: function (scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    scope.status = {
                        iwoPath: {
                            // 融合编辑器iwo路由，判断是否实在基础稿
                            iwonews: true,
                            iwoatlas: true,
                            iwolinkdoc: true,
                            iwovideo: true,
                            iwobroadcasttvmanuscript: true,
                        },
                        canSelectReoprt: false, // 判断是否是基础稿件，只有基础稿件可以进行关联选题的操作
                        isSwitchReportAudit: $sessionStorage.get('curUserInfo').SWITCHREPORTAUDIT === 'true', // 代表是否打开选题审核
                    };
                    publicToolService.getModeconfiguration('draftRelevance').then((config) => {
                        scope.status.shield = config.shield;
                    });
                    
                }

                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if (scope.status.shield) {return;} // 若需要屏蔽则不继续执行
                    var report = localStorageService.get('report');
                    var task = localStorageService.get('task');
                    var reportid = $state.params.reportid;
                    var taskid = $state.params.taskid;
                    // 基础稿可以使用全局变量cureditpage来判断，像广电文稿这些没有基础搞得使用路由名称判断
                    scope.status.canSelectReoprt = !!scope.status.iwoPath[scope.$root.cureditpage || $state.current.name];
                    if (scope.status.canSelectReoprt && report && reportid && reportid === report.NEWREPORTID) {
                        scope.selectedReport = report;
                        localStorageService.remove('report');
                    }
                    if (scope.status.canSelectReoprt && task && taskid && taskid === task.TASKCOMMANDID) {
                        scope.selectedTask = task;
                        localStorageService.remove('task');
                    }
                    if ((scope.status.canSelectReoprt && !scope.selectedReport) || scope.isFusionEditor === 'false') {
                        getReport();
                    }
                    if ((scope.status.canSelectReoprt && !scope.selectedTask) || scope.isFusionEditor === 'false') {
                        getTask();
                    }
                }

                /**
                 * [relatedReport description] 点击选择选题函数
                 * @return  {[type]}  [return description]
                 */
                scope.relatedReport = function () {
                    editingCenterService.relatedReport(scope.selectedReport).then(function (data) {
                        scope.selectedReport = data.data;
                    });
                };

                /**
                 * [relatedTask description] 点击选择任务函数
                 * @return  {[type]}  [return description]
                 */
                scope.relatedTask = function () {
                    editingCenterService.relatedReport(scope.selectedTask, 'task').then(function (data) {
                        scope.selectedTask = data.data;
                    });
                };

                /**
                 * [deleteSelected description]删除选中报题或者任务
                 *
                 * @param   {[type]}  data  [data description] 一个标识符
                 *
                 * @return  {[type]}        [return description]
                 */
                scope.deleteSelected = function (data) {
                    data === 'task' ? (scope.selectedTask = {}) : (scope.selectedReport = {});
                };

                /**
                 * @description: 获取稿件所关联的任务
                 * @return  {[type]}  [return description]
                 */
                function getTask() {
                    if (!scope.metaDataId) {
                        return;
                    }
                    var params = {
                        serviceid: 'mlf_taskcommand',
                        methodname: 'queryRelateTaskCommandByMetaDataId',
                        MetaDataId: scope.metaDataId,
                        MediaType: scope.mediaType,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        scope.selectedTask = data;
                    });
                }

                /**
                 * @description: 获取稿件所关联的报题
                 * @return  {[type]}  [return description]
                 */
                function getReport() {
                    if (!scope.metaDataId) {
                        return;
                    }
                    var params = {
                        serviceid: 'mlf_newreport',
                        methodname: 'queryRelateReportByMetaId',
                        MetaDataId: scope.metaDataId,
                        MediaType: scope.mediaType,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        scope.selectedReport = data;
                    });
                }
            },
        };
    },
]);
